import { generateAuthHeader } from "../../../../commonfunctions/authentication";
import { Address } from "../../../../interfaces/interfaces";
import { subdomainTypes } from "../../../../context/availableSubdomains";
import { formatShipParamsForSave } from "../../../../components/Address/util";

const API_BASE = process.env.REACT_APP_HALFBACK_ROOT_API;

export const addressService = {
  async fetchAll(): Promise<Address[]> {
    const res = await fetch(`${API_BASE}/ship_to_addresses/saved`, generateAuthHeader());
    const data = await res.json();
    return data;
  },

  async delete(addressId: number): Promise<void> {
    const res = await fetch(`${API_BASE}/ship_to_addresses/delete`, {
      method: "POST",
      body: JSON.stringify({ address_id: addressId }),
      headers: {
        ...generateAuthHeader().headers,
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      const error = await res.text();
      throw new Error(error);
    }
  },

  async update(address: Address, branch: subdomainTypes | ""): Promise<void> {
    const params = formatShipParamsForSave(address, branch);

    const res = await fetch(`${API_BASE}/ship_to_addresses/update`, {
      method: "POST",
      body: JSON.stringify(params),
      headers: {
        ...generateAuthHeader().headers,
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      const error = await res.text();
      throw new Error(error);
    }
  },
};
